import { Container } from "react-bootstrap";
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <Container className="footerContainer">
      <small className="footerText">
        © IETEC {currentYear} | Alle Rechte vorbehalten.
      </small>
    </Container>
  );
};

export default Footer;
